export const logos = {
  strava: '/app-logos/strava/logo.png',
  instagram: '/app-logos/instagram/logo.png',
  facebook: '/app-logos/facebook/logo-medium.png',
  googlePhotos: '/app-logos/google-photos/google-photos.svg',
};